var map = {
	"./courses/1.webp": 103,
	"./dayday/1.png": 1435,
	"./dayday/2.png": 3665,
	"./dayday/3.png": 3126,
	"./dayday/4.png": 6298,
	"./dayday/5.png": 833,
	"./dayday/6.png": 6658,
	"./dayday/7.png": 936,
	"./employees-list/1.png": 454,
	"./employees-list/2.png": 7085,
	"./employees-list/3.png": 2385,
	"./employees-list/4.png": 5712,
	"./employees-list/5.png": 5831,
	"./epic-login/1.webp": 1910,
	"./front-gate-mind-palace/1.png": 1162,
	"./front-gate-mind-palace/2.png": 4847,
	"./match-masters/1.png": 4385,
	"./match-masters/2.png": 2214,
	"./match-masters/3.png": 3037,
	"./match-masters/4.png": 3804,
	"./match-masters/5.png": 3260,
	"./movies-vote/1.png": 5616,
	"./movies-vote/2.png": 6395,
	"./movies-vote/3.png": 6851,
	"./petcare/1.png": 1919,
	"./petcare/10.png": 8907,
	"./petcare/11.png": 7172,
	"./petcare/12.png": 2185,
	"./petcare/13.png": 6719,
	"./petcare/2.png": 2800,
	"./petcare/3.png": 9007,
	"./petcare/4.png": 2825,
	"./petcare/5.png": 8973,
	"./petcare/6.png": 7974,
	"./petcare/7.png": 5173,
	"./petcare/8.png": 1145,
	"./petcare/9.png": 8927,
	"./tech-blog/1.png": 5982,
	"./tech-blog/2.png": 8858,
	"./tech-blog/3.png": 5709,
	"./tech-blog/4.png": 9103,
	"./tech-blog/5.png": 8423,
	"./tech-blog/6.png": 2266,
	"./upload-form/1.webp": 4641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2148;